/**
 * Blog Recommendations Component
 * Handles dynamic loading and display of related blog posts
 */

class BlogRecommendations extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.articleId = this.dataset.articleId;
    this.blogHandle = this.dataset.blogHandle;
    this.url = this.dataset.url;
    this.recommendationsPerformed = this.dataset.recommendationsPerformed === 'true';
    
    this.init();
  }

  init() {
    this.validateData();
  }

  validateData() {
    const issues = [];
    
    if (!this.articleId || this.articleId === 'null' || this.articleId === '') {
      issues.push('No article ID found - recommendations may not work on article pages');
    }
    
    if (!this.blogHandle || this.blogHandle === 'null' || this.blogHandle === '') {
      issues.push('No blog handle found - cannot fetch related blogs');
    }
    
    if (!this.url || this.url === 'null' || this.url === '') {
      issues.push('No blog URL found');
    }

    const resourceList = this.querySelector('.resource-list');
    const items = resourceList ? resourceList.querySelectorAll('.resource-list__item') : [];
    
    if (items.length === 0) {
      issues.push('No related articles found to display');
    }

    return issues;
  }

  triggerRecommendations() {
    this.dataset.recommendationsPerformed = 'true';
  }
}

customElements.define('blog-recommendations', BlogRecommendations);
